import { createSlice } from "@reduxjs/toolkit"
import { ApiStatus } from "../../types/api/status"
import { RootState } from "../store"
import { CartolaBuilding, CartolaBuildingInit } from "../../types/slices/cartolaBuildingType"

const initialState: CartolaBuildingInit =
{
    status: ApiStatus.FETCHED,
    cartolaBuildings: [],
    totalRows: 0,
    errorMessage: undefined,
    selectedCartolaBuilding: undefined,
}

const cartolaBuildingSlice = createSlice({
    name: 'cartolaBuildingSlice',
    initialState,
    reducers: {
        onFetchCartolaBuildings(state, { payload }: { payload: CartolaBuilding[] }) {
            state.status = ApiStatus.FETCHED
            state.cartolaBuildings = payload
            state.errorMessage = undefined
        },
        onSetTotalRows(state, { payload }: { payload: number }) {
            state.totalRows = payload
        },
        changeStatus(state, { payload }: { payload: ApiStatus }) {
            state.status = payload
        },
        onSetSelectedCartolaBuilding(state, { payload }: { payload: CartolaBuilding | undefined }) {
            state.selectedCartolaBuilding = payload
        },
    }
})

export const cartolaBuildingState = (state: RootState) => state.cartolaBuildingSlice
export default cartolaBuildingSlice.reducer

export const {
    onFetchCartolaBuildings,
    changeStatus,
    onSetSelectedCartolaBuilding,
    onSetTotalRows
} = cartolaBuildingSlice.actions